export const SUNSET_PAYWALL_CTA_URL =
  process.env.REACT_APP_SUNSET_PAYWALL_URL ||
  'https://app.musiversal.com/signup?invitation_code=studio_upgrade_member_jun26';

export const SUNSET_PAYWALL_ONDEMAND_CTA_URL =
  process.env.REACT_APP_SUNSET_PAYWALL_ONDEMAND_URL ||
  'https://app.musiversal.com/signup?invitation_code=studio_upgrade_ondemand_jun26';
